import React from "react";
import isEmpty from "lodash.isempty";
import { REACT_APP_MAP_KEY, MALAGA_CENTER } from "../../constants";

import SearchBox from "./../../components/Map/SearchBox";
import GoogleMap from "./../../components/Map/GoogleMap";
import Marker from "./../../components/Map/Marker";
import Geolocate from './../../components/Geolocate';

const MUNICIPIO_RADIUS_METERS = 15000; // 15 km

export class LocationGoogle extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // OTHER MAP
      mapApiLoaded: false,
      mapInstance: null,
      mapApi: null,
      geocoder: null,
      places: [],
      posLat: null,
      posLng: null,
    };
    this.child = React.createRef();

    this.handleGeolocation = this.handleGeolocation.bind(this)
  }

  // OTHER MAP
  apiHasLoaded = (map, maps) => {
    this.setState({
      mapApiLoaded: true,
      mapInstance: map,
      mapApi: maps,
      geocoder: new maps.Geocoder()
    });


    if (this.props.municipio) {
      this.centerOnMunicipio(this.props.municipio, map, maps);
    }
  };

  componentDidUpdate(prevProps) {
    if (
      this.props.municipio &&
      this.props.municipio !== prevProps.municipio &&
      this.state.mapApiLoaded
    ) {
      this.centerOnMunicipio(
        this.props.municipio,
        this.state.mapInstance,
        this.state.mapApi
      );
    }

    const toNumber = (v) => {
      const n = Number(String(v).replace(",", "."));
      return Number.isFinite(n) ? n : null;
    };
    const prevOpt = prevProps?.values?.streetOptions;
    const currOpt = this.props?.values?.streetOptions;

    const prevLat = prevOpt?.x;
    const prevLng = prevOpt?.y;
    const currLatRaw = currOpt?.x;
    const currLngRaw = currOpt?.y;

    if (!this.state.mapApiLoaded) return;

    const currLat = toNumber(currLatRaw);
    const currLng = toNumber(currLngRaw);
    
    const coordsChanged = prevLat !== currLatRaw || prevLng !== currLngRaw;

    // Si se ha limpiado ubicación, limpiamos marcador
    if ((!currLat || !currLng) && coordsChanged) {
      this.setState({ places: [] });
      return;
    }

    // Solo si vienen coordenadas válidas (edificio tiene Lat/Lng)
    if (coordsChanged && currLat && currLng) {
      const { mapApi, mapInstance } = this.state;

      // Centrar mapa
      const latLng = new mapApi.LatLng(currLat, currLng);
      mapInstance.setCenter(latLng);
      mapInstance.setZoom(17);

      // Crear "place" compatible con tu render (usa lat()/lng())
      const place = {
        place_id: `formik-${currLat}-${currLng}`,
        name: currOpt?.nombreEdificio || "",
        geometry: {
          location: {
            lat: () => currLat,
            lng: () => currLng
          }
        }
      };

      this.setState({ places: [place] });
    }
  }

  centerOnMunicipio = (municipio, map, mapApi) => {
    //console.log("[Municipio] Geocodificando municipio:", municipio);
    const geocoder = new mapApi.Geocoder();

    geocoder.geocode({ address: municipio }, (results, status) => {
      if (status === mapApi.GeocoderStatus.OK && results[0]) {
        const location = results[0].geometry.location;

        //console.log( "[Municipio] Centro:", location.lat(), location.lng() );

        this.setState({ municipioLatLng: location });
        map.setCenter(location);
        map.setZoom(14);
      }
    });
  };


  addPlace = place => {
    const places = [place];
    this.setState({ places });
  };

  createMapOptions = maps => {
    return {
      panControl: false,
      mapTypeControl: false,
      scrollwheel: false,
      gestureHandling:
        "greedy" /*,
      styles: [
        {
          stylers: [
            { saturation: -100 },
            { gamma: 0.8 },
            { lightness: 4 },
            { visibility: "on" }
          ]
        }
      ]*/
    };
  };

  handleGeolocation(data) {
    const { coords } = data;
    const { mapApi, mapInstance, municipioLatLng } = this.state;

    if (!mapApi || !mapInstance) return;

    const userLatLng = new mapApi.LatLng(coords.latitude, coords.longitude);

    if (!municipioLatLng) {
      // console.log("[Geolocate] Municipio todavía no geocodificado, esperando...");
      return; // No hacemos nada hasta que se defina municipioLatLng
    }

    const distance = mapApi.geometry.spherical.computeDistanceBetween(userLatLng, municipioLatLng);

    if (distance <= MUNICIPIO_RADIUS_METERS) {
      mapInstance.setCenter(userLatLng);
      mapInstance.setZoom(15);
    } else {
      mapInstance.setCenter(municipioLatLng);
      mapInstance.setZoom(14);
    }
  }
  _onClick = ({ lat, lng, event }) => {
    // ✅ 1) Ignorar clicks en controles (zoom, fullscreen, etc.)
    try {
      const el = event?.target;
      if (el?.closest) {
        // Controles de Google suelen vivir dentro de .gmnoprint / .gm-control-active
        if (
          el.closest(".gmnoprint") ||
          el.closest(".gm-control-active")
        ) {
          return;
        }
      }
    } catch (e) { }

    // ✅ 2) Si por lo que sea no hay coordenadas, salir
    if (lat == null || lng == null || !this.state.mapApi) return;

    const latlng = new this.state.mapApi.LatLng({ lat, lng });
    const geocoder = new this.state.mapApi.Geocoder();

    geocoder.geocode({ location: latlng }, (results, status) => {
      if (status === this.state.mapApi.GeocoderStatus.OK) {
        const { 0: place } = results;
        const { mapInstance } = this.state;
        if (!place?.geometry) return;

        // mantener el click
        place.geometry.location = latlng;

        mapInstance.setCenter(place.geometry.location);
        mapInstance.setZoom(mapInstance.getZoom());

        this.setState({ places: [place] });

        // esto actualiza el input y la ubicación
        this.child.current.handleSelectSuggest(place, true);
      } else {
        console.error("Geocode error: " + status);
      }
    });
  };


  render() {
    // OTHER MAP
    const { places, mapApiLoaded, mapInstance, mapApi } = this.state;
    const { entity, t } = this.props;

    const municipio = this.props.municipio || entity?.Nombre || "";

    return (
      <>
        {mapApiLoaded && (
          <SearchBox
            map={mapInstance}
            mapApi={mapApi}
            municipio={municipio}
            addplace={this.addPlace}
            ref={this.child}
            value={this.props.value}
            onSearchGecorStreet={this.props.onSearchGecorStreet}
            onSuccessLocation={this.props.onSuccessLocation}
            {...this.props}
          />
        )}
        {mapApiLoaded && (<div style={{ display: "none" }}>
          <Geolocate onSuccess={this.handleGeolocation} t={t} /></div>)}
        <GoogleMap
          tabIndex={-1}
          defaultZoom={13}
          defaultCenter={entity
            ? [parseFloat(entity.Latitud), parseFloat(entity.Longitud)]
            : MALAGA_CENTER
          }
          bootstrapURLKeys={{
            key: REACT_APP_MAP_KEY,
            libraries: ["places", "geometry"]
          }}
          yesIWantToUseGoogleMapApiInternals
          options={this.createMapOptions}
          onClick={this._onClick}
          onGoogleApiLoaded={({ map, maps }) => this.apiHasLoaded(map, maps)}
        >
          {!isEmpty(places) &&
            places.map(
              (place, index) =>
                place && (
                  <Marker
                    key={place.place_id || index}
                    text={place.name || ""}
                    lat={place.geometry.location.lat()}
                    lng={place.geometry.location.lng()}
                  />
                )
            )}
        </GoogleMap>
      </>
    );
  }
}

export default LocationGoogle;
